import React from 'react';


const Footer  = (props) => {
    return <div style={{textAlign:'center', padding: '1.5rem'}}>OfficeMojo - Automated Reminders  1.7.f <br />&copy; ProSites 2020</div>
}

export {Footer};